/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlImpersonateOTTResponse
 */
export interface ControlImpersonateOTTResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlImpersonateOTTResponse
     */
    ott: string;
}

/**
 * Check if a given object implements the ControlImpersonateOTTResponse interface.
 */
export function instanceOfControlImpersonateOTTResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ott" in value;

    return isInstance;
}

export function ControlImpersonateOTTResponseFromJSON(json: any): ControlImpersonateOTTResponse {
    return ControlImpersonateOTTResponseFromJSONTyped(json, false);
}

export function ControlImpersonateOTTResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlImpersonateOTTResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ott': json['ott'],
    };
}

export function ControlImpersonateOTTResponseToJSON(value?: ControlImpersonateOTTResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ott': value.ott,
    };
}

